import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#333333',
        error: '#DF2323',
        warning: '#FF8A1F',
      },
    },
  },
  iconfont: 'md',
};

export default new Vuetify(opts);
